<section class="cms_events">
	<h1 i18n="@@CmsEvent">Events</h1>

	<app-cms-events-table [events_user_id]="this.events_user_id"></app-cms-events-table>
